import axios from 'axios';

export default {

    //Permet de récupérer le plan de classement
    getClassificationPlan() {
        //prefix doit ici etre parcourir ou concours
        return axios.get(process.env.VUE_APP_API_URI + '/api/classificationPlan');
        },

    //Permet de récupérer les critères d'une catégorie
    getCriterion(userId, category) {
        return axios.get(process.env.VUE_APP_API_URI + '/api/objectifMonitoring/' + userId + '/criterion/' + category);
    },

    //Permet de récupérer les informations d'un critère
    getCriteriaDetail(userId, category, criteria, period) {
        return axios.get(process.env.VUE_APP_API_URI + '/api/objectifMonitoring/' + userId + '/criteria/' + category + '/detail/' + criteria + '/' + period);
    },

    //Permet de récupérer le classement des utilisateurs sur un critère
    getCriteriaRanking(userId, category, criteria, period, type) {
        return axios.get(process.env.VUE_APP_API_URI + '/api/objectifMonitoring/' + userId + '/criteria/' + category + '/detail/' + criteria + '/' + period + '/classement/' + type);
    },

    //Permet de récupérer la liste des commerciaux
    getCommercialList(userId, length = 20, search = null, startIndex = 0, filter = null) {
        let params = '?length=' + length;
        if(search != null){
            params = params + '&search=' + search;
        }
        if(startIndex != null){
            params = params + '&start_index=' + startIndex;
        }
        if(filter != null){
            params = params + '&filter=' + filter;
        }
        return axios.get(process.env.VUE_APP_API_URI + '/api/objectifMonitoring/' + userId + '/commercial' + params);
    },

    //Permet de récupérer la liste des commerciaux mis en favoris
    getFollowCommercialList(userId) {
        return axios.get(process.env.VUE_APP_API_URI + '/api/objectifMonitoring/' + userId + '/commercial/follow');
    }
}
